export interface SasToken {
  token?: string;
  expireAt?: string;
  startsAt?: string;
}

export interface SasTokenResult {
  sasToken?: SasToken;
}

export interface GetDisruptionsRequest {
  mapOnly?: boolean;
  sourceType?: SourceType;
  startDate?: string;
  showExpired?: boolean;
  tenantId?: number;
}

export interface GetDisruptionsResponse {
  disruptions: Disruption[];
}

export enum SourceType {
  Automated = 'Automated',
  Manual = 'Manual',
}

export enum ShapeType {
  None = 'None',
  Point = 'Point',
  Polygonal = 'Polygonal',
}

export enum GeoJsonType {
  Point = 'Point',
  MultiPoint = 'MultiPoint',
  LineString = 'LineString',
  MultiLineString = 'MultiLineString',
  Polygon = 'Polygon',
  MultiPolygon = 'MultiPolygon',
  GeometryCollection = 'GeometryCollection',
  Feature = 'Feature',
  FeatureCollection = 'FeatureCollection',
}

export interface Geometry {
  type?: GeoJsonType;
  coordinates?: number[][][];
}

export interface Feature {
  geometry?: Geometry;
  properties?: { [key: string]: any; } | undefined;
  type?: GeoJsonType;
}

export enum GeometryType {
  Point = 'Point',
  MultiPoint = 'MultiPoint',
  LineString = 'LineString',
  MultiLineString = 'MultiLineString',
  Polygon = 'Polygon',
  MultiPolygon = 'MultiPolygon',
  GeometryCollection = 'GeometryCollection',
}

export interface AffectedArea {
  features?: Feature[];
  geometryType?: GeometryType;
}

export interface GeoPosition {
  latitude?: number;
  longitude?: number;
}

export enum WaypointType {
  NotSpecified = 'NotSpecified',
  Building = 'Building',
  Truck = 'Truck',
}

export interface Place {
  city?: string;
  state?: string;
  country?: string;
  county?: string;
  zip?: string;
}

export enum RouteType {
  NotCompleted = 'NotCompleted',
  Completed = 'Completed',
}

export enum ResultOption {
  None = 'None',
  Polyline = 'Polyline',
}

export enum RoutingProfile {
  DefaultGlobalTruck = 'DefaultGlobalTruck',
  ContractualGlobalTruck = 'ContractualGlobalTruck',
  ContractualEUTruck = 'ContractualEUTruck',
  MappingGlobalTruck = 'MappingGlobalTruck',
}

export interface Waypoint {
  geoPosition?: GeoPosition;
  stopTypeLabel: string;
  userLabel?: string;
  type?: WaypointType;
  place?: Place;
  status: string;
}

export interface Disruption {
  _id?: string;
  createdOn?: string;
  updatedOn?: string;
  stormKey?: string;
  name?: string;
  description?: string;
  sourceType?: SourceType;
  source?: string;
  geometryType?: ShapeType;
  affectedArea?: AffectedArea;
  incidentDate?: string;
  expirationDate?: string;
  tenant?: number;
  incidentJobField?: string;
  incidentJobFieldValue?: string;
}

export enum LocationSource {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export interface Coordinate {
  latitude?: number;
  longitude?: number;
}

export interface Address2 {
  type: string;
  coordinate?: Coordinate;
  address1?: string;
  address2?: string;
  city?: string;
  stateProvince?: string;
  stateProvinceName?: string;
  postalCode?: string;
  countryCode?: string;
  countryName?: string;
  continent?: string;
  isResidential?: boolean;
  stateProvinceCenter?: Coordinate;
  countryCenter?: Coordinate;
  continentCenter?: Coordinate;
}

export interface DatePair {
  utc?: string;
  local?: string;
}

export interface CurrentLocation extends Address2 {
  source?: LocationSource;
  lastUpdateDateTime?: DatePair;
  liveTracked?: boolean;
}
